var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseSolidW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9963 6.98633C13.9963 7.47852 13.6317 7.86406 13.2185 7.86406H12.4406L12.4577 12.2445C12.4577 12.3184 12.4528 12.3922 12.4455 12.466V12.9062C12.4455 13.5105 12.0104 14 11.4732 14H11.0843C11.0575 14 11.0308 14 11.0041 13.9973C10.97 14 10.936 14 10.902 14H10.112H9.52859C8.99139 14 8.55628 13.5105 8.55628 12.9062V12.25V10.5C8.55628 10.016 8.20868 9.625 7.77844 9.625H6.22275C5.79251 9.625 5.44491 10.016 5.44491 10.5V12.25V12.9062C5.44491 13.5105 5.0098 14 4.4726 14H3.88922H3.11381C3.07734 14 3.04088 13.9973 3.00442 13.9945C2.97525 13.9973 2.94608 14 2.91691 14H2.52799C1.99079 14 1.55569 13.5105 1.55569 12.9062V9.84375C1.55569 9.81914 1.55569 9.7918 1.55812 9.76719V7.86406H0.777844C0.340307 7.86406 0 7.48125 0 6.98633C0 6.74023 0.0729229 6.52148 0.243076 6.33008L6.47555 0.21875C6.6457 0.0273438 6.84016 0 7.01032 0C7.18047 0 7.37493 0.0546875 7.52078 0.191406L13.7289 6.33008C13.9234 6.52148 14.0206 6.74023 13.9963 6.98633Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSolidW);
export default __webpack_public_path__ + "static/media/house-solid-w.f1481ce50987bf2b8d1f8b116907bfef.svg";
export { ForwardRef as ReactComponent };